import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { StaticPillList } from './../../../reusable/Form/PillList';
import { hashHistory } from 'react-router';
import { CATEGORIES_ENTITIES_VISIBLE_COUNT } from './../../../constants';
import { withPermission } from './../../../context';

class CategoryEntitiesPillList extends Component {
    static propTypes = {
        category: PropTypes.object.isRequired,
        entities: PropTypes.array.isRequired,
        onRemoveEntity: PropTypes.func,
        visibleItemCount: PropTypes.number,
        permission: PropTypes.object
    }

    static defaultProps = {
        visibleItemCount: CATEGORIES_ENTITIES_VISIBLE_COUNT,
        permission: { canEdit: true }
    }

    constructor(props) {
        super(props);

        this.handleRemoveEntity = this.handleRemoveEntity.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
    }

    handleRemoveEntity(entity) {
        this.props.onRemoveEntity(this.props.category, entity);
    }

    handleShowMore() {
        this.props.handleShowMore(this.props.category);
    };

    render = () => <StaticPillList items={this.props.entities}
                                   onRemoveItem={this.props.permission.canEdit && this.props.onRemoveEntity && this.handleRemoveEntity}
                                   visibleItemCount={this.props.visibleItemCount}
                                   onShowMore={this.handleShowMore}/>
}

export default withPermission(CategoryEntitiesPillList);


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/CategoryEntitiesPillList.jsx